export default __webpack_public_path__ + "static/media/desk-illustration.6da0f8f3.svg";